import { initialState } from "./state"

export const setAccountFlags = (state, payload) => {
  state.accountFlags = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
